<template>
  <div class="lavorazioni">
    <div class="default-container content-lavorazioni">
      <h1>{{ pageApiData.title }}</h1>
      <h4 v-html="pageApiData.subTitle"></h4>
      <p v-html="pageApiData.content"></p>
    </div>

    <listing-lavorazioni
      :list="pageApiData.sections"
      :lang="lang" />
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import ListingLavorazioni from '@/components/ListingLavorazioni'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    ListingLavorazioni
  }
}
</script>

<style lang="scss">

  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .lavorazioni{

    background-color: #1d1d1b;
    padding-top: 14rem;

    @media #{$medium_mq} {
      padding-top: 20rem;
    }
    @media #{$large_mq} {
      padding-top: 23rem;
    }

    .content-lavorazioni{
      padding-bottom: 4rem;
      @media #{$medium_mq} {
        padding-bottom: 8rem;
      }
      h1{
        @include size-16-pixel(#EFEFF1);
        letter-spacing: .2rem;
        text-transform: uppercase;
        font-family: 'Roboto'; font-weight: 500;
        margin-bottom: 0;
      }
      h4 {
        @include section-title(#545454);
        font-family: 'Sectra'; font-weight: 400;
        margin-top: 2rem;
        br{
          display: none;
          @media #{$xlarge_mq} {
            display: block;
          }
        }
      }
      p{
        @include section-paragraph(#EFEFF1);
        strong{
          color: #679196;
          font-family: 'Roboto'; font-weight: 300;
        }
      }
      br{
          display: none;
          @media #{$medium_mq} {
            display: block;
          }
        }
    }

    .listing-lavorazioni ul{
      padding-bottom: 90px;
      @media #{$medium_mq} {
        padding-bottom: 130px;
      }
      @media #{$large_mq} {
        padding-bottom: 160px;
      }
      @media #{$xlarge_mq} {
        padding-bottom: 190px;
      }
    }

    .listing-lavorazioni__content{
      position: relative;
      padding: 4rem 0;
      border-top: 1px solid #4A4A4A;
      transform: translate3d(0, 0, 0);
      top: 0;
      display: block;
      z-index: 20;

      h3{
        font-size: 4.8rem;
        line-height: 1.2;
      }

      p{
        font-size: 1.6rem;
        line-height: 1.8;
      }

      .hero-cta{
        padding: 2rem 0;
      }

      @media #{$medium_mq} {
        .default-container{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          min-height: 250px;
        }

        h3{
          font-size: 4.2rem;
          line-height: 1.2;

          width: 35%;
          align-self: center;
          margin: 1rem 0 2rem;
        }
        p{
          font-size: 1.2rem;
          line-height: 1.6;

          width: 53%;
          padding-right: 10%;
          padding-left: 10%;
          align-self: center;
        }
        .hero-cta{
          width: 12%;
          text-align: right;
          align-self: center;
          img{
            margin-right: 0;
          }
        }

      }

      @media #{$large_mq} {
        h3{
          font-size: 4.6rem;
          line-height: 1.2;
        }
        p{
          font-size: 1.5rem;
          line-height: 1.6;
        }
      }

      @media #{$xlarge_mq} {
        h3{
          font-size: 7.7rem;
          width: 35%;
        }
        p{
          font-size: 1.8rem;
          width: 53%;
        }
      }

    }

    .listing-lavorazioni__content--desktop{
      display: none;
    }
  }

</style>
